import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: fit-content;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	gap: 1rem;
	background-color: ${color.interface.white};
	transition: all ease 0.5s;
`;

export const dubleBanner = styled.div`
	width: 100%;
	display: grid;
	gap: 10px;
	grid-template-columns: 1fr 1fr;
	padding: 10px;
`;

export const tripleBanner = styled.div`
	width: 100%;
	display: grid;
	gap: 10px;
	grid-template-columns: 1fr 1fr 1fr;
	padding: 10px;
`;

export const tripleBannersLeftOrRight = styled.div`
	width: 100%;
	display: grid;
	gap: 10px;
	grid-template-columns: 1fr 1fr;
	padding: 10px;
`;

export const twoBannersColumn = styled.div`
	width: 100%;
	max-height: 40vh;
	display: grid;
	grid-template-rows: 1fr 1fr;
	gap: 10px;
	padding: 10px;
`;

export const mosaic4Banners = styled.div`
	width: 100%;
	max-height: 40vh;
	display: grid;
	grid-template-rows: repeat(
		3,
		minmax(0, 1fr)
	); // Restringe as alturas ao máximo permitido
	gap: 10px;
	padding: 10px;
	overflow: hidden; // Corta qualquer coisa que ultrapasse a altura definida

	> div {
		width: 100%;
		height: 100%;
		display: grid;
		gap: 10px;
		grid-template-columns: 1fr 1fr;
	}
`;

export const mosaic3Banners = styled.div`
	width: 100%;
	max-height: 40vh;
	height: 100%;
	display: grid;
	grid-template-rows: 1fr 1fr;
	gap: 10px;
	padding: 10px;
	overflow: hidden; // Corta qualquer coisa que ultrapasse a altura definida

	> div {
		width: 100%;
		height: 100%;
		display: grid;
		gap: 10px;
		grid-template-columns: 1fr 1fr;
	}
`;

export const img = styled.img`
	min-width: 100%;
	min-height: 100%;
	max-width: 100%;
	max-height: 100%;
	width: 100%;
	height: 100%;
	object-fit: fill; // Evita distorção, mas pode criar espaços em branco
	border-radius: 10px;
`;

export const noGrid = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	> p {
		font-size: 1.4rem;
	}
`;
